import { Info } from "lucide-react";
import { UrduInput } from "../../../../Components/Shared/UrduInput";

export default function BasicInfoSection({ form, categories, brands }) {
  const {
    formData,
    register,
    validationErrors,
    isCategoryDropdownOpen,
    setIsCategoryDropdownOpen,
    categoryDropdownRef,
    toggleCategory,
    handleChange,
    productId,
    productToEdit,
  } = form;

  const isActive = String(formData.status) === "true";
  const canToggleStatus = !!(productId || productToEdit);

  const selectedCategoryLabel = (() => {
    if (!formData.categoryIds?.length) return "";
    const first = categories.find((c) => c.id === formData.categoryIds[0]);
    if (formData.categoryIds.length === 1) return first?.name || "";
    return `${formData.categoryIds.length} selected`;
  })();

  return (
    <section data-field="basic-info" className="pf-card">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <h3 className="pf-section-title">Basic Information</h3>
        {/* {canToggleStatus && (
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500">
              Status: {isActive ? "Active" : "Inactive"}
            </span>
            <button
              type="button"
              role="switch"
              aria-checked={isActive}
              className={`pf-toggle ${isActive ? "on" : ""}`}
              onClick={() =>
                handleChange({
                  target: {
                    name: "status",
                    value: isActive ? "false" : "true",
                  },
                })
              }
            />
          </div>
        )} */}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div data-field="name">
          <label className="pf-label">
            Product Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            {...register("name")}
            placeholder="Enter product name"
            className={`pf-input ${validationErrors.name ? "is-error" : ""}`}
          />
          {validationErrors.name && (
            <p className="text-red-500 text-xs mt-1">{validationErrors.name}</p>
          )}
          <UrduInput
            label="پروڈکٹ کا نام"
            name="productName_ur"
            value={formData.productName_ur}
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="pf-label">Brand</label>
          <select
            name="brandId"
            value={formData.brandId}
            onChange={handleChange}
            className="pf-select"
          >
            <option value="">Select Brand</option>
            {Array.isArray(brands) && brands.length > 0 ? (
              brands.map((brand) => (
                <option key={brand.id} value={String(brand.id)}>
                  {brand.name}
                </option>
              ))
            ) : (
              <option disabled>No brands added yet</option>
            )}
          </select>
        </div>

        <div
          className="relative"
          ref={categoryDropdownRef}
          data-field="categories"
        >
          <label className="pf-label">
            Category <span className="text-red-500">*</span>
          </label>
          <button
            type="button"
            onClick={() => setIsCategoryDropdownOpen(!isCategoryDropdownOpen)}
            className={`pf-input text-left flex items-center justify-between ${
              validationErrors.categories ? "is-error" : ""
            }`}
          >
            <span
              className={
                formData.categoryIds.length ? "text-gray-800" : "text-gray-400"
              }
            >
              {selectedCategoryLabel || "Select category"}
            </span>
            <svg
              className={`w-4 h-4 text-gray-400 transition-transform ${
                isCategoryDropdownOpen ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {formData.categoryIds.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-2">
              {formData.categoryIds.map((catId) => {
                const category = categories.find((cat) => cat.id === catId);
                if (!category) return null;
                return (
                  <span
                    key={catId}
                    className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-semibold bg-brand-primary/10 text-brand-primary"
                  >
                    {category.name}
                    <button
                      type="button"
                      onClick={() => toggleCategory(catId)}
                      aria-label={`Remove ${category.name}`}
                    >
                      ×
                    </button>
                  </span>
                );
              })}
            </div>
          )}

          {isCategoryDropdownOpen && (
            <div
              className="absolute z-50 w-full mt-1 bg-white border border-[var(--pf-border)] rounded shadow-lg max-h-60 overflow-y-auto"
              onMouseDown={(e) => e.stopPropagation()}
            >
              {categories.map((category) => (
                <label
                  key={category.id}
                  className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-50 last:border-0"
                >
                  <input
                    type="checkbox"
                    checked={formData.categoryIds.includes(category.id)}
                    onChange={() => toggleCategory(category.id)}
                    className="w-4 h-4 accent-brand-primary"
                  />
                  <span className="ml-3 text-sm text-gray-700">
                    {category.name}
                  </span>
                </label>
              ))}
            </div>
          )}
          {validationErrors.categories && (
            <p className="text-red-500 text-xs mt-1">
              {validationErrors.categories}
            </p>
          )}
        </div>

        <div>
          <label className="pf-label inline-flex items-center gap-1">
            Custom URL
            <span className="relative group inline-flex">
              <Info className="w-3 h-3 text-gray-400" />
              <span className="absolute z-10 hidden group-hover:block bg-gray-800 text-white text-[10px] rounded py-1.5 px-2 left-0 top-full mt-1 w-44">
                Optional slug for product page URL
              </span>
            </span>
          </label>
          <input
            type="text"
            name="customUrl"
            value={formData.customUrl}
            onChange={handleChange}
            placeholder="e.g. sikaseal-105"
            className="pf-input"
          />
        </div>
      </div>
    </section>
  );
}
